import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_RR,
} from "constants/FormatDataContanst";
import PropTypes from "prop-types";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import ListInvoicePosBatchDetail from "./ListInvoicePosBatchDetail";

const ListInvoicePosOfPhase = forwardRef((props, ref) => {
  const { phaseId } = props;

  const listInvoicePosRef = useRef();

  const [filterList, setFilterList] = useState({
    "filter[batch_id]": phaseId,
  });

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  useImperativeHandle(ref, () => ({
    queryData() {
      listInvoicePosRef?.current?.queryData();
    },
  }));

  // Action list chang tenantCode
  useEffect(() => {
    if (listInvoicePosRef) {
      listInvoicePosRef?.current?.queryData();
    }
  }, []);

  return (
    <React.Fragment>
      <ListInvoicePosBatchDetail
        ref={listInvoicePosRef}
        isModal={true}
        filterList={filterList}
        // screenFilterCode={SCREEN_FILTER_CODE.INVOICE_POS_OF_PHASE}
        listStatusFilter={[
          AUTH_STATUS_NEW,
          AUTH_STATUS_APPROVE,
          AUTH_STATUS_PROGRESSING,
          AUTH_STATUS_REJECT,
          AUTH_STATUS_CANCEL_WAITING,
          AUTH_STATUS_REJECT_CANCEL,
          AUTH_STATUS_CANCEL,
          AUTH_STATUS_AR,
          AUTH_STATUS_RR,
        ]}
        title={"DANH SÁCH HÓA ĐƠN CỦA ĐỢT"}
        titleManger={"HÓA ĐƠN"}
      />
    </React.Fragment>
  );
});

ListInvoicePosOfPhase.propTypes = {
  phaseId: PropTypes.any,
};

ListInvoicePosOfPhase.defaultProps = {
  phaseId: null,
};

export default ListInvoicePosOfPhase;
